import React, { useEffect, useState } from 'react'
import OrganizationSub from './OrganizationSub';

export default function DomainName({ forCount, countTotal, evaluationShow, evaluationId, domain, index }) {
    useEffect(() => {
    }, [])

    return (
        <>
            <h2 className="accordion-header mb-2 px-0" id={domain ? `${domain.replaceAll(' ', '')?.replaceAll('&', '')}` : 'uxd'}>
                <button className="accordion-button-custom collapsed border-0 bg-transparent pb-2 bold-text font-15" type="button" data-bs-toggle="collapse" data-bs-target={domain ? `#${domain.replaceAll(' ', '')?.replaceAll('&', '')}main` : "#uxdmain"} aria-expanded="false" aria-controls={domain ? `${domain.replaceAll(' ', '')?.replaceAll('&', '')}main` : "uxdmain"}>
                    {domain} <span>({countTotal})</span>
                </button>
            </h2>
            <OrganizationSub forCount={forCount} evaluationShow={evaluationShow} evaluationId={evaluationId} team={domain} />
        </>
    )
}
